import {User} from "./user";

export interface Build {
    id: string,
    version_number: string,
    component: string,
    release_notes: string,
    release_link: string,
    link?: string,
    checksum?: string,
    track: string,
    platform: string,
    deployment_type: string,
    released_at: string,
    created_at: string,
    updated_at: string
}

export const BuildTrackChoices = [
    {label: "Stable", value: "stable"},
    {label: "Beta", value: "beta"},
    {label: "Development", value: "dev"},
];

export const BuildPlatformChoices = [
    {label: "MacOSX", value: "macos"},
    {label: "Windows", value: "windows"},
    {label: "Linux", value: "linux"},
    {label: "Web", value: "web"},
    {label: "Android", value: "android"},
    {label: "iOS", value: "ios"},
    {label: "Docker", value: "docker"},
];

export interface DownloadHistory {
    user?: User,
    build?: Build,
    timestamp: string
}

export interface BuildCheckSum {
    build: Build,
    checksum: string,
    created_at: string
}

export interface BuildVersionCompatability {
    server_version: string,
    client_version: string,
    is_compatible?: boolean,
    created_at?: string
}

export interface CompatibilityMatrix {
    server_build: string, // build uuid
    client_build: string, // build uuid
    compatible: boolean,
}

export interface AdminCompatabilityMatrixResponse{
    client_compatibility?: CompatibilityMatrix[],
    server_compatibility?: CompatibilityMatrix[],
    all_records: CompatibilityMatrix[],
    no_compatibility?: string[],
    build_list: Build[],
}

export interface UserCompatabilityMatrixResponse{
    compatible_builds: CompatibilityMatrix[],
    builds: Build[],
}

export interface PromoteBuildByVersionRequest {
    version: string;
    component: "client" | "version";
    release_notes?: string;
}

export interface PromoteBuildByVersionResponse {
    version_number: string;
    promoted: PromotedBuild[];
    skipped?: SkippedPromotedBuild[];
}

export interface PromotedBuild {
    original_build: Build;
    promoted_build: Build;
    from_track: string;
    to_track: string;
}

export interface SkippedPromotedBuild {
    build_id: string;
    platform: string;
    component: string;
    track: string;
    reason: string;
}

export interface BuildReleaseNotesModificationRequest {
    version: string;
    component: string;
    release_notes: string;
}

